import { render, staticRenderFns } from "./DeviceFan.vue?vue&type=template&id=24df0676&scoped=true&"
import script from "./DeviceFan.vue?vue&type=script&lang=js&"
export * from "./DeviceFan.vue?vue&type=script&lang=js&"
import style0 from "./DeviceFan.vue?vue&type=style&index=0&id=24df0676&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24df0676",
  null
  
)

export default component.exports